import { Image } from '@mantine/core';
import Images from 'assets/img/Images';
import {
  Button,
  Colors,
  Text,
  TypesButton,
  Typography,
} from 'goalsetter-webapp-components';
import { t } from 'i18next';
import { QrDescriptionContainer, downloadButtonStyle } from './styles';
import { useMediaQueryGs } from 'app/hooks/useMediaQuery';
import { sendAnalyticsEvent } from '../../../utils/analytics/analyticsWrapper';
import { ActionType, CategoryType } from '../../../types/analytics/enum';

function DownloadApp() {
  const { isMobile } = useMediaQueryGs();

  const goToDownloadApp = () => {
    sendAnalyticsEvent(
      CategoryType.downloadButton,
      ActionType.Goalcard_FinalScreen_DownloadButton,
    );
    window.open('https://preview.page.link/goalsetter.page.link/download');
  };

  return (
    <QrDescriptionContainer>
      <Text
        type={Typography.GSH5}
        color={Colors.PURPLE_DARK}
      >
        {isMobile ? t('downloadApp.downloadApp') : t('downloadApp.scanQr')}
      </Text>

      {isMobile && (
        <Button
          type={TypesButton.PRIMARY}
          onClick={goToDownloadApp}
          style={downloadButtonStyle}
        >
          {t('downloadApp.downloadAppButton')}
        </Button>
      )}
      {!isMobile && (
        <Image
          src={Images.QR}
          width="96px"
        />
      )}
    </QrDescriptionContainer>
  );
}

export default DownloadApp;
